import { FormattedDistance } from '../i18n';

import type { RelevantPOI } from '@shared/types/frontend/hotel-card';

type Props = {
  relevantPOI: RelevantPOI;
};

const DistancePOI = ({ relevantPOI: { distance, name } }: Props) => (
  <FormattedDistance
    label="Distance_label_fromPlace"
    distanceMeters={distance}
    data={{
      place: name,
    }}
  />
);

export default DistancePOI;
